<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32">
        <title>diposal</title>
        <path :fill="color"
         d="M9 4v3a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4h4a1 1 0 0 1 1 1v24a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zm11.5 15H11a1 1 0 0 0-1 1l.007.117A1 1 0 0 0 11 21h7.556l-1.37 1.919a1 1 0 1 0 1.628 1.162l2.5-3.5A1 1 0 0 0 20.5 19m-5.919-7.314a1 1 0 0 0-1.395.233l-2.5 3.5A1 1 0 0 0 11.5 17H21a1 1 0 0 0 1-1l-.007-.117A1 1 0 0 0 21 15h-7.558l1.372-1.919a1 1 0 0 0-.233-1.395M20 2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-8a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z"/></svg>
</template>
<script setup lang="ts">
defineProps({
    color: {
        type: String,
        default: 'currentColor'
    }
});
</script>
